import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Dashboard as DashboardIcon,
  Inventory as InventoryIcon,
  ShoppingCart as ShoppingCartIcon,
  Mail as MailIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";

const SidebarNavigation: React.FC = () => {
  return (
    <div>
      <List>
        <ListItem button component={Link} to="/my-biz/my-listings">
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="My Listings" />
        </ListItem>
        <ListItem button component={Link} to="/my-biz/my-inventory">
          <ListItemIcon>
            <InventoryIcon />
          </ListItemIcon>
          <ListItemText primary="My Inventory" />
        </ListItem>
        <ListItem button component={Link} to="/my-biz/orders">
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary="Orders" />
        </ListItem>
        <ListItem button component={Link} to="/my-biz/purchases">
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary="Purchases" />
        </ListItem>
        <ListItem button component={Link} to="/my-biz/my-connections">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="My Connections" />
        </ListItem>
        {/* Wrap the disabled ListItem in a Box with Tooltip */}
        <Tooltip title="Coming soon" arrow>
          <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
            <ListItem button disabled>
              <ListItemIcon>
                <MailIcon />
              </ListItemIcon>
              <ListItemText primary="Inbox" />
            </ListItem>
          </Box>
        </Tooltip>
        {/* Wrap the disabled ListItem in a Box with Tooltip */}
        <Tooltip title="Coming soon" arrow>
          <Box sx={{ display: "flex", alignItems: "center", cursor: "not-allowed" }}>
            <ListItem button disabled>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItem>
          </Box>
        </Tooltip>
      </List>
      <Divider />
    </div>
  );
};

export default SidebarNavigation;
